<template>
  <div class="full-height">
    <el-menu
      class="el-menu-aside"
      :router=true
      :unique-opened=true
      default-active="/project"
      text-color="#FFFFFF"
      active-text-color="#FFFFFF"
    >
      <div class="logo">webhorsting</div>
      <transition name="fade">
        <div v-if="!projectChosen" class="menu-placeholder">
          <h4>Welcome!</h4>Please choose<br>your project<br><i class="el-icon-arrow-right"></i>
        </div>
      </transition>
      <transition name="fade">
        <div v-if="projectChosen" class="menu-content">
          <el-menu-item index="/" @click="resetProject">
            <i class="fas fa-arrow-circle-left"></i>
            <span>Home</span>
          </el-menu-item>
          <el-menu-item index="/project">
            <i class="fas fa-th-large"></i>
            <span>Project dashboard</span>
          </el-menu-item>
          <el-menu-item index="/domains">
            <i class="fas fa-bars"></i>
            <span>Domains</span>
          </el-menu-item>
          <el-menu-item index="/emails">
            <i class="fas fa-at"></i>
            <span>Emails</span>
          </el-menu-item>
          <el-menu-item index="/databases">
            <i class="fas fa-database"></i>
            <span>Databases</span>
          </el-menu-item>
          <el-menu-item index="/marketing">
            <i class="fas fa-chart-line"></i>
            <span>Marketing</span>
          </el-menu-item>
          <el-menu-item index="/advanced">
            <i class="fas fa-cogs"></i>
            <span>Advanced</span>
          </el-menu-item>
        </div>
      </transition>
    </el-menu>
  </div>
</template>
<script>
export default {
  props: ['projectChosen'],
  data: () => ({}),
  methods: {
    resetProject() {
      this.$emit('projectReset', true);
    },
  },
};
</script>
<style lang="scss">
$mainColor: #00D457;

.menu-content {
  position: absolute;
  top: 71px;
  left: 0;
  width: 100%;
}

.menu-placeholder {
  width: 100%;
  position: absolute;
  top: 71px;
  left: 0;
  font-size: 20px;
  font-weight: 300;
  color: #FFFFFF;

  h4 {
    font-weight: 500;
    margin-top: 90px;
    margin-bottom: 5px;
  }

  i {
    padding-top: 10px;
  }
}

.el-menu-aside {
  height: 100%;
  background-color: $mainColor !important;

  .logo {
    font-family: 'Quicksand', sans-serif;
    font-size: 2.4rem;
    font-weight: 500;
    letter-spacing: 0.1rem;
    margin: 0 40px;
    height: 70px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #FFFFFF;
  }

  a {
    text-decoration: none;
  }

  .submenu--dropdown {
    .el-menu-item {
      background-color: rgb(1, 192, 81);
    }
  }

  .el-menu-item,
  .el-submenu__title {
    height: 60px;
    display: flex;
    align-items: center;
    padding-left: 40px !important;
    background-color: $mainColor;
    i {
      color: #FFFFFF;
    }

    &:hover,
    &.is-active {
      background-color: rgb(7, 163, 72);
    }
  }

  .el-submenu {
    .el-menu-item {
      padding-left: 60px !important;
    }
  }

  .fas {
    padding-right: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SideMenu.vue